import PropTypes from 'prop-types';
import React from 'react';

import './ControlledWidthContainerEightHundred.scss';

export default class ControlledWidthContainerEightHundred extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
    };

    render() {
        return (
            <div
                className={`component-Layout-ControlledWidthContainerEightHundred ${this.props.className}`}
            >
                {this.props.children}
            </div>
        );
    }
}
